(function () {
  function getCarousel(section) {
    return section.querySelector('[data-fclo-others-carousel]');
  }

  function getFlickityButtons(section) {
    var carousel = getCarousel(section);
    if (!carousel) return {};

    return {
      prev: carousel.querySelector('.flickity-button.previous'),
      next: carousel.querySelector('.flickity-button.next')
    };
  }

  function getFlickityInstance(carousel) {
    if (!carousel || !window.Flickity) return null;
    return window.Flickity.data(carousel);
  }

  function resizeCarousel(section) {
    var carousel = getCarousel(section);
    var instance = getFlickityInstance(carousel);
    if (!instance) return;
    instance.reloadCells();
    instance.resize();
  }

  function advanceCarousel(section, direction) {
    var carousel = getCarousel(section);
    if (!carousel) return;

    var flickity = getFlickityButtons(section);
    if (direction < 0 && flickity.prev) {
      flickity.prev.click();
      return;
    }
    if (direction > 0 && flickity.next) {
      flickity.next.click();
      return;
    }

    var instance = getFlickityInstance(carousel);
    if (instance) {
      if (direction < 0) instance.previous();
      else instance.next();
      return;
    }

    var scrollEl = carousel.querySelector('.flickity-viewport') || carousel;
    var slide = carousel.querySelector('.product-grid-slide');
    var gap = 12;
    var distance = slide ? slide.getBoundingClientRect().width + gap : 280;
    scrollEl.scrollBy({ left: direction * distance, behavior: 'smooth' });
  }

  function syncNav(section) {
    var flickity = getFlickityButtons(section);
    var prevBtns = section.querySelectorAll('[data-fclo-others-prev]');
    var nextBtns = section.querySelectorAll('[data-fclo-others-next]');

    prevBtns.forEach(function (btn) {
      btn.disabled = !flickity.prev || flickity.prev.disabled;
    });
    nextBtns.forEach(function (btn) {
      btn.disabled = !flickity.next || flickity.next.disabled;
    });
  }

  function watchImages(section) {
    section.querySelectorAll('.fclo-others__image').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        resizeCarousel(section);
        syncNav(section);
      });
    });
  }

  function bindNav(section) {
    if (section.dataset.fcloOthersBound === 'true') return;
    section.dataset.fcloOthersBound = 'true';

    var prevBtns = section.querySelectorAll('[data-fclo-others-prev]');
    var nextBtns = section.querySelectorAll('[data-fclo-others-next]');
    if (!prevBtns.length) return;

    prevBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        advanceCarousel(section, -1);
        window.setTimeout(function () { syncNav(section); }, 80);
      });
    });

    nextBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        advanceCarousel(section, 1);
        window.setTimeout(function () { syncNav(section); }, 80);
      });
    });

    watchImages(section);

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        resizeCarousel(section);
        syncNav(section);
      }, 150);
    });

    var tries = 0;
    var retry = window.setInterval(function () {
      resizeCarousel(section);
      syncNav(section);

      var flickity = getFlickityButtons(section);
      if (flickity.prev && window.MutationObserver && !section.dataset.fcloOthersObserved) {
        section.dataset.fcloOthersObserved = 'true';
        new MutationObserver(function () { syncNav(section); }).observe(flickity.prev, {
          attributes: true,
          attributeFilter: ['disabled']
        });
        if (flickity.next) {
          new MutationObserver(function () { syncNav(section); }).observe(flickity.next, {
            attributes: true,
            attributeFilter: ['disabled']
          });
        }
      }

      tries += 1;
      if (tries > 30) window.clearInterval(retry);
    }, 200);
  }

  function initSection(section) {
    if (!section || !section.classList.contains('fclo-others')) return;
    bindNav(section);
  }

  document.querySelectorAll('[data-section-type="fclo-others-also-bought"]').forEach(initSection);

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    var section = target.matches('[data-section-type="fclo-others-also-bought"]')
      ? target
      : target.querySelector('[data-section-type="fclo-others-also-bought"]');
    if (section) {
      section.dataset.fcloOthersBound = '';
      section.dataset.fcloOthersObserved = '';
      initSection(section);
    }
  });
})();
